import { Badge } from '@compass/Badge'
import Skeleton from '@mui/material/Skeleton'
import clsx from 'clsx'

import { SuspectScoreDisplayProps } from './calculateSuspectScoreDisplayProps'

export function SuspectScoreIndicator({ displayProps }: { displayProps?: SuspectScoreDisplayProps }) {
  const { activeLine, tickPosition, tickColor, tickText } = displayProps ?? {}

  return (
    <div className='relative'>
      <div className='grid gap-0.5 grid-cols-[75fr_20fr_5fr]'>
        <div
          className={clsx(
            'h-1 rounded-full border',
            activeLine === 'green' ? 'bg-green-500 border-green-600' : 'bg-green-300 border-green-400'
          )}
        />
        <div
          className={clsx(
            'h-1 rounded-full border',
            activeLine === 'yellow' ? 'bg-yellow-500 border-yellow-600' : 'bg-yellow-300 border-yellow-400'
          )}
        />
        <div
          className={clsx(
            'h-1 rounded-full border',
            activeLine === 'red' ? 'bg-red-500 border-red-700' : 'bg-red-300 border-red-400'
          )}
        />
      </div>
      <div className={`relative inline-block -mt-2 ${tickPosition ?? 'left-[69.5%]'}`}>
        {tickColor ? <div className={`h-3 w-1.5 ${tickColor} border-2 border-white border-y-0`} /> : null}
        {tickText ? (
          <Badge variant='subtle' tone='secondary' className='tabular-nums mt-1 -translate-x-1/2'>
            {tickText}
          </Badge>
        ) : (
          <Skeleton width={44} height={20} className='transform-none mt-4 -translate-x-1/2' />
        )}
      </div>
    </div>
  )
}
